import axios from 'axios'
import { baseURL } from './config'

const client = axios.create({
    baseURL,
})

client.interceptors.request.use((config) => {
    // Do something before request is sent
    const accessToken = localStorage.getItem('publicAccessToken')
    if (accessToken) {
        config.headers.Authorization = `Token ${accessToken}`
    }

    return config
}, (e) => {
    // Do something with request error
    return Promise.reject(e)
})

export const request = async (type, url, params, clientParams = {}) => {
    try {
        let response
        switch (type) {
            case 'GET':
                response = await client.get(url, { params })
                break
            case 'POST':
                response = await client.post(url, params, clientParams)
                break
        }

        return response?.data
    } catch (e) {
        const errors = e?.response?.data?.errors || []

        return Promise.reject(errors)
    }
}

export default client
